import { FileUploadRequest, FileActions } from "@/business/files/domain/files";
import { loadInventoryService } from "@/business/files/infrastructure/services/loadInventoryService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const loadInventory = {
    async execute(file: File): Promise<void> {
        const request: FileUploadRequest =
            FileActions().uploadFileRequest(
                file
            );
        await loadInventoryService.execute(await tokenValidation.execute(), request);
    },
};